import { Datepicker, TextField } from '@petsmart-ui/sparky';
import moment, { type Moment } from 'moment';
import type { InputEvent } from 'react';

import type { SitePreviewData } from '@libs/common-next';

import { config } from './config';
import css from './date-picker.module.scss';
import { dateToAz, validateTime } from './utils';

type Props = {
    name: keyof SitePreviewData;
    value?: string | boolean;
    onChange: (key: keyof SitePreviewData, value?: string) => void;
};

export function DatePicker({ name, value, onChange }: Props) {
    const date = value ? moment(dateToAz(value as string)) : null;
    const time = date?.format('HH:mm');

    const onDateChange = (newDate: Moment | null) => {
        handleChange(newDate, '00:00');
    };

    const onTimeChange = ({ currentTarget }: InputEvent<HTMLInputElement>) => {
        if (validateTime(currentTarget.value)) {
            handleChange(date, currentTarget.value);
        }
    };

    const handleChange = (date: Moment | null, time: string) => {
        if (!date || !time) return;
        const [hours, minutes] = time.split(':');
        date.set({ hour: Number.parseInt(hours, 10), minute: Number.parseInt(minutes, 10) });
        onChange(name, date.format('YYYY-MM-DDTHH:mm:ss-07:00'));
    };

    return (
        <div className={css.wrapper}>
            <div className="site-preview-pickers">
                <Datepicker
                    date={date}
                    label="Date"
                    placeholder=""
                    numberOfMonths={1}
                    onDateChange={onDateChange}
                    isOutsideRange={() => false}
                    withFullScreenPortal={false}
                />

                <TextField
                    label="Time"
                    mask={config}
                    defaultValue={time ?? date?.format('HH:mm')}
                    onInput={onTimeChange}
                />
            </div>

            <button
                type="button"
                className={css.reset}
                style={{ visibility: date ? 'visible' : 'hidden' }}
                onClick={() => onChange(name, undefined)}
                aria-label="Clear date"
            >
                ⊘
            </button>
        </div>
    );
}
